import ButtonsContainer from "@common/controls/Container/Buttons";

const FormButtons = ButtonsContainer;
export default FormButtons;
